import { object, string, date } from "yup";

export interface FormData {
  nextContactDate: Date | null;
  reason: string | null;
}

export const schema = object({
  nextContactDate: date().required("Next contact date is required"),
  reason: string().required("Reason required").min(1, "Reason required")
});
